import Clipboard from './Clipboard/clipboard';
import loadMore from './loadMore';
import drap from './drap';

export const clipboard = Clipboard;

export default {
  loadMore,
  Clipboard,
  drap
};